import React from 'react'
import styled from 'styled-components'
import {useMediaQuery} from '@mui/material'
import TypographyAtom from '../typography/typography.atom'
import footerStyles from './footer.styles'
import utils from '../../../utils'
import {LinkProps, Footer} from '../../../props_reusable/labels'

interface ApFooterProps {
  label: Footer
  routes: LinkProps
}
const StyleWrapperAtom = styled.div`
  ${footerStyles}
`

interface FooterLink {
  label: string
  link: string
}

interface LinksProp {
  links: FooterLink[]
}

const separateLink = (
  label: LinkProps,
  links: LinkProps,
  isMobileView: boolean,
) => {
  const firstLineLinks: FooterLink[] = []
  const secondLineLinks: FooterLink[] = []
  let index = 0
  // eslint-disable-next-line
  for (const [key, value] of Object.entries(links)) {
    const labelVal = label[key as keyof typeof label]
    const link = value
    if (labelVal && link) {
      if (index < 3 || !isMobileView) {
        firstLineLinks.push({
          label: labelVal,
          link,
        })
        index += 1
      } else {
        secondLineLinks.push({
          label: labelVal,
          link,
        })
        index += 1
      }
    }
  }
  return {firstLineLinks, secondLineLinks}
}

const Links: React.FC<LinksProp> = function ({links}) {
  return (
    <>
      {links.map(d => {
        const link = utils.stringToUri(d.link)
        return (
          <a
            href={link}
            target="_blank"
            className="active"
            key={d.label}
            rel="noreferrer"
          >
            <TypographyAtom ahd_type="mLink">{d.label}</TypographyAtom>
          </a>
        )
      })}
    </>
  )
}

const FooterAtom = function (props: ApFooterProps) {
  const {label, routes} = props
  const {ap_year, ap_title, term} = label
  const matches = useMediaQuery('(max-width:480px)')
  const {firstLineLinks, secondLineLinks} = separateLink(
    label.links,
    routes,
    matches,
  )
  return (
    <StyleWrapperAtom>
      {term && <TypographyAtom ahd_type="sData">{term}</TypographyAtom>}
      {firstLineLinks.length !== 0 && (
        <div>
          <Links links={firstLineLinks} />
        </div>
      )}
      {secondLineLinks.length !== 0 && (
        <div>
          <Links links={secondLineLinks} />
        </div>
      )}
      {ap_title && (
        <TypographyAtom ahd_type="sData">
          {'\u00A9'} {ap_year} {ap_title}
        </TypographyAtom>
      )}
    </StyleWrapperAtom>
  )
}

export default FooterAtom
